<app-ehe-header [auth]="true"></app-ehe-header>
<div class="account-wrapper general-wrapper">
	<div class="container">
		<div class="row">
			<div class="col-md-12">
				<router-outlet></router-outlet>
			</div>
		</div>
	</div>
</div>
<app-ehe-footer [socialNetwork]="true"></app-ehe-footer>
<app-ehe-spinner></app-ehe-spinner>
